module.exports = __webpack_public_path__ + "img/hx-zlgl.7e8a3d43.svg";